import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByPropertyLabel',
  standalone: false,
})
export class FilterByPropertyLabelPipe implements PipeTransform {
  transform(
    items: any[],
    searchText: string,
    filterEnabled: boolean = true,
  ): any[] {
    // If the filter is disabled, return the original items
    if (!filterEnabled) {
      return items;
    }
    if (!items) return [];
    if (!searchText) return items;

    searchText = searchText.toLowerCase();

    return items.filter((it) => {
      return it.propertyLabel?.toLowerCase().includes(searchText);
    });
  }
}
